/**
 * @file src/components/AppHeader.tsx
 * Top bar mirroring the email-pdf brand pattern (Fowix · WhatsApp PDF +
 * Support / Privacy nav). MUI here, Tailwind there — same shape.
 */

import { Box, Stack, Typography, Link as MuiLink } from '@mui/material'
import { PictureAsPdf } from '@mui/icons-material'

export const AppHeader = () => (
  <Box
    component="header"
    sx={{
      px: { xs: 2, sm: 3 },
      py: 2,
      borderBottom: '1px solid',
      borderColor: 'grey.200',
      bgcolor: 'background.paper',
    }}
  >
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ maxWidth: 1100, mx: 'auto' }}
    >
      <MuiLink
        href="https://fowix.io"
        underline="none"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: '#1E2A3B',
          fontWeight: 600,
        }}
      >
        <PictureAsPdf sx={{ fontSize: 20 }} />
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          Fowix · WhatsApp PDF
        </Typography>
      </MuiLink>
      <Stack direction="row" spacing={3} sx={{ fontSize: '0.875rem' }}>
        <MuiLink
          href="mailto:support@fowix.io"
          underline="hover"
          color="text.secondary"
          sx={{ fontSize: '0.875rem' }}
        >
          Support
        </MuiLink>
        <MuiLink
          href="https://fowix.io/privacy"
          underline="hover"
          color="text.secondary"
          sx={{ fontSize: '0.875rem' }}
        >
          Privacy
        </MuiLink>
      </Stack>
    </Stack>
  </Box>
)
